export default "<app-salary-simulation [btnShowDetails]=\"true\">\n\n</app-salary-simulation>\n"